import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

import { GridspaceLogo, MixerLogo } from './Components.js'
import './PageWrapper.scss';

// nick code moved to the front for documentation purposes
const generalLinks = [
  { link: '/', text: 'Home' }, // register and log in
  { link: '/faq/', text: 'FAQ' }, // FAQ for mixerlab users
  { link: '/profile/me', text: 'Profile' }, // basic, payment, and performance information
  { link: '/actor/', text: 'Actor Home' }, // actor and bot sessions
  // { link: '/profile/leaderboard', text: 'Leaderboard'}, // actor and slack performance rankings
  { link: '/profile/logout', text: 'Log Out' },
]
// Maybe TODO: make an admin_bp and move Actor Admin (/admin/actor) and Slack Admin (/admin/slack) under Admin Home tab
const adminLinks = [
  { link: '/admin/', text: 'Admin Home'}, // FAQ, (Actor Admin, Slack Admin,) View All Users, Pay Users
  { link: '/actor/admin', text: 'Actor Admin'}, // kick off actor and bot sessions, write session spec, button to update actor tiers
  { link: '/slack/', text: 'Slack Admin'}, // view active and dormant tasks, create new task, button to update slack tiers
  { link: '/dayna/', text: 'Dayna Scripts'}, // view dayna scripts, generate dayna script
  { link: '/dashboards/', text: 'Model Dashboards'}, // ask phoebe
]

const Container = styled.div`
  margin-top: 40px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.isAdminPage ? '#ebf3f7' : '#F8F8F8'};
  font-family: Inter;

  @media only screen and (min-width: 576px) {
    max-width: 540px;
  }
  
  @media only screen and (min-width: 768px) {
    width: 55rem;
    max-width: 720px;
  }
  
  @media only screen and (min-width: 992px) {
    width: 58rem;
    max-width: 960px;
  }
  
  @media only screen and (min-width: 1200px) {
    width: 61rem;
    max-width: 1140px;
  }

  @media only screen and (min-width: 1440px) {
    width: 80rem;
  }
`
const Nav = styled.nav`
  background-color: #204860;
  padding: 10px;
  padding-top: 26px;
  padding-bottom: 26px;
  padding-left: 37px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  display: flex;
`

const NavLogo = styled.a`
padding-right: 35px;
  svg {
    display: inline-block;
    width: 95px;
    height: 18.299px;
    flex-shrink: 0;
  }
`

const NavLink = styled.a`
  margin-right: 35px;
  color: #fff;

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration: none;
  font-family: Inter;

  border-bottom: ${props => props.underLine ? '1.5px solid currentColor' : 'none'};
  padding-top: ${props => props.underLine ? 2.5 : 0}px;
`

const getNavLink = (linkInfo, i) => {
  let isMatch = window.location.pathname === linkInfo.link
  // let linkStyle = isMatch ? '2px solid currentColor' : 'none'
  return (
    <NavLink key={i} href={linkInfo.link} underLine={isMatch}>{linkInfo.text}</NavLink>
  )
}

class NavBar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const isAdmin = Boolean(parseInt(this.props.isAdmin));
    const generalNavlinks = generalLinks.map((linkInfo, i) => getNavLink(linkInfo, i));
    let adminNavLinks = null;
    
    if (isAdmin) {
      adminNavLinks = adminLinks.map((linkInfo, i) => getNavLink(linkInfo, i));
    }

    return (
      <Nav>
        <NavLogo href='/'><MixerLogo /></NavLogo>
        {generalNavlinks}
        {adminNavLinks}
      </Nav>
    )
  }
}

class PageWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { basicNav, className, isAdmin } = this.props;
    let isAdminPage = adminLinks.some(item => item.link === window.location.pathname);
    isAdminPage = ((isAdmin) && (isAdminPage))

    return (
      <div id={this.props.id} className={classnames('page-wrapper', className)} 
            style={{'backgroundColor': isAdminPage ? '#ebf3f7' : '#F8F8F8', 'minHeight': '100vh'}}>
        <NavBar basicView={basicNav} isAdmin={this.props.isAdmin}/>
        {isAdminPage &&
            <h2>ADMIN VIEW</h2>}
        {this.props.noContainer &&
          <div>
            {this.props.children}
          </div>
        }
        {!this.props.noContainer &&
          <Container isAdminPage={isAdminPage}>
            {this.props.children}
          </Container>
        }
      </div>
    );
  }
}


PageWrapper.defaultProps = {
  padded: true,
  basicNav: false
}

window.getImgStaticUrl = (img) => {
  if (window.static_url.startsWith("//")) {
    return "https:" + window.static_url + img;
  } else {
    return window.static_url + img;
  }
}

export default PageWrapper;
export { Nav, NavLink };

// TODO add footer conditional on being admins
